<template>
<div>
  <div v-if='withAccreditation && result && result.data' class='caption' >
    <div class='white--text caption pl-3 py-0 my-0'>Backgrounds by Unsplash.
      <a
        :href='result.data.links.html + "?utm_source=AppointmentGuru&utm_medium=referral&utm_campaign=api-credit"'
        target='_blank'
        class='grey--text' >image</a>
        by
      <a
        :href='result.data.user.links.html + "?utm_source=AppointmentGuru&utm_medium=referral&utm_campaign=api-credit"'
        target='_blank'
        class='grey--text' >{{result.data.user.name}}</a>
      <!-- <v-btn @click='changeBackground' class='ml-0 pl-0' small icon ><v-icon small >replay</v-icon></v-btn> -->

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'RandomSplash',
  data () {
    return {
      result: {}
    }
  },
  props: {
    withAccreditation: true,
    withDescription: true
  },
  mounted () {
    this.changeBackground()
  },
  methods: {
    changeBackground () {
      let payload = {
        headers: {
          Authorization: 'Client-ID e844ef6b655e466ae6355a7ad45e990ca3f96928ad4fa9dc1e6a3939592a3039'
        }
      }
      let vm = this
      axios.get('https://api.unsplash.com/photos/random?collections=1145600', payload)
        .then((data) => {
          vm.result = data
          let appStyle = {
            'backgroundImage': `url('${data.data.urls.regular}')`,
            'backgroundSize': 'cover'
          }
          this.$emit('unpashbackground', appStyle)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// RandomSplash.vue?7aa602c8